module.exports = {
  "ditto_component_library": {
    "base": require('./ditto-component-library__base.json'),
    "english": require('./ditto-component-library__english.json'),
    "new-coverages-2025": require('./ditto-component-library__new-coverages-2025.json')
  }
}